import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { useCallback, useEffect } from 'react';
import ErrorBoundary from './ErrorBoundary';
import { NavMarker } from 'react-rhumb';
import { FULL_COMPONENT_CRASH_MARK } from '../performance/markers';
import { getObjectTypeForLogging } from '../performance/lib/utils';
import { Metrics } from 'crm-object-board-core/performance';
import { captureException, createBoardError } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorComponentInner = ({
  objectTypeId,
  error
}) => {
  useEffect(() => {
    const boardError = createBoardError('Unhandled error', error);
    captureException(boardError, error, {
      tags: {
        FULL_COMPONENT_CRASH: 'true'
      }
    });
    Metrics.counter(FULL_COMPONENT_CRASH_MARK.name, {
      objectTypeId: getObjectTypeForLogging(objectTypeId)
    }).increment();
  }, [error, objectTypeId]);

  // The below nav marker will mark any route on any app as a failure
  // Please see docs here for more information on the navmarker
  // https://product.hubteam.com/docs/frontend/docs/react-rhumb.html#error-boundaries-and-repeatable-errors
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "badRequest",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "RHUMB_GLOBAL_ERROR"
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmObjectBoard.error.unknown"
      })
    })]
  });
};

/**
 * BoardErrorWrapper is the last last line of defense for errors in the CrmObjectBoardWrapper Component.
 * Please avoid adding any logic to this component.
 * If you would like to provide helpful error scenario user experiences, please do so in the ErrorState component.
 *
 * ErrorState is "we were able to somewhat predict this error" and ErrorComponent is "**** hit the fan, we are in survival mode"
 */
export const BoardErrorWrapper = ({
  objectTypeId,
  children
}) => {
  const ErrorComponent = useCallback(({
    error
  }) => /*#__PURE__*/_jsx(ErrorComponentInner, {
    error: error,
    objectTypeId: objectTypeId
  }), [objectTypeId]);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    ErrorComponent: ErrorComponent,
    children: children
  });
};